import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import React, { useRef, useState } from 'react';
export interface ObsessionVideoProps {
  urlDesktop: string | undefined;
  urlMobile: string | undefined;
}
export const ObsessionVideo: React.FC<ObsessionVideoProps> = ({
  urlDesktop,
  urlMobile,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [hasStartedPlaying, setHasStartedPlaying] = useState(false);

  useIntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && videoRef.current) {
          if (!hasStartedPlaying) {
            videoRef.current.play();
            setHasStartedPlaying(true);
          }
        } else if (videoRef.current && !hasStartedPlaying) {
          videoRef.current.pause();
        }
      });
    },
    videoRef,
    { threshold: 0.75 },
  );

  return (
    <>
      <div className="w-full">
        <video
          ref={videoRef}
          className="w-full h-full md:h-full hidden md:flex"
          playsInline
          autoPlay
          loop
          muted
        >
          <source src={urlDesktop} type="video/mp4" />
        </video>
        <video
          ref={videoRef}
          className="w-full h-full md:h-full md:hidden"
          playsInline
          autoPlay
          loop
          muted
        >
          <source src={urlMobile} type="video/mp4" />
        </video>
      </div>
    </>
  );
};
